import getColor from "@insite/mobius/utilities/getColor";
import { TYPOGRAPHY } from "@store/theme/common/design";
import polyfillCss from "@store/theme/common/polyfillCss";

export default {
    defaultProps: {
        typographyProps: null,
        color: null,
        iconProps: {
            size: 10,
            css: polyfillCss`
                width: 15.5px;
                height: 15.5px;
                min-width: 15.5px;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                background-color: ${getColor("tertiary.main")};
                color: ${getColor("tertiary.contrast")};
            `,
        },
        css: polyfillCss`
            align-items: center;
            min-height: 0;
            max-width: none;
            background-color: ${getColor("common.accent")};
            color: ${getColor("common.accentContrast")};
            font-size: ${TYPOGRAPHY.size.smaller};
            line-height: ${TYPOGRAPHY.lineHeight.small};
            padding: 0.5em 0.75em;
            border-radius: 4px;
            word-break: break-all;

            button {
                min-width: 0;
                min-height: 0;
                background-color: transparent !important;
                padding: 0.2em;
                margin-left: 5px;
                box-sizing: content-box;
                color: ${getColor("text.disabled")};
                border-radius: inherit;

                &:hover {
                    color: ${getColor("common.accentContrast")};
                }
            }
        `,
    },
};
